<template>
  <!-- <div style="background-color: #fff; padding: 10px"> -->
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef"></div>
    <div class="bar-rig">
      <div class="rig-one" @click="handleOpenModal">
        <a-button class="btn-primary">添加成员</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
    :columns="columns"
    :customRow="customRow"
    :dataSource="dataSource"
    :loading="searchLoading"
    :pagination="false"
    :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
    class="table"
    size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'weixin'">
        <span>
          {{ record.nickname }}
          <a-button type="link" @click="handleOpenBand(record)">
            <span v-if="!record.nickname">绑定微信</span>
            <span v-else>重新绑定</span>
          </a-button>
        </span>
      </template>
      <template v-if="column.key == 'operation'">
        <a-button type="link" @click="handleEdit(record)">修改</a-button>
        <a-button v-if="record.status == 1" type="link" @click="handleEditStatus(record, 2)">停用</a-button>
        <a-button v-else type="link" @click="handleEditStatus(record, 1)">启用</a-button>
        <a-button danger type="link" @click="handleDelNumber(record)">删除</a-button>
      </template>
    </template>
  </a-table>

  <!-- 弹窗 -->
  <a-modal v-model:visible="visibleAdd" :title="modalTitle" :width="600" @ok="addSave">
    <a-form ref="formRef" :label-col="{ span: 4 }" :model="addForm" :rules="rules" hideRequiredMark labelAlign="left">
      <a-form-item label="姓名：" name="name">
        <a-input v-model:value="addForm.name" placeholder="请输入姓名" style="width: 100%"></a-input>
      </a-form-item>
      <a-form-item label="手机号：" name="phone">
        <a-input v-model:value="addForm.phone" placeholder="请输入手机号" style="width: 100%"></a-input>
      </a-form-item>
      <a-form-item label="邮箱：" name="email">
        <a-input v-model:value="addForm.email" placeholder="用于接收通知（可选）" style="width: 100%"></a-input>
      </a-form-item>

      <a-form-item label="房间：" name="hid">
        <a-select
          v-model:value="addForm.hids"
          :filter-option="false"
          :max-tag-count="4"
          allowClear
          mode="multiple"
          placeholder="请选择房间（可选）"
          show-search
          style="width: 100%"
          @focus="searchRoom"
          @search="roomFilter"
        >
          <a-select-option v-for="(item, index) in roomList" :key="index" :value="item.id">{{ item.name }} </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="权限：" name="auth">
        <a-select v-model:value="addForm.auth" placeholder="请选择支付方式">
          <a-select-option :value="1">不限制</a-select-option>
          <a-select-option :value="2">禁止查看房态</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="备注：" name="remark">
        <a-textarea v-model:value="addForm.remark" :rows="4" placeholder="请输入描述（可选）" />
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 绑定微信弹窗 -->
  <a-modal v-model:visible="visibleBand" :footer="null" :width="400" :zIndex="9999" @cancel="getTableData">
    <div class="weixin">
      <div>请成员使用微信扫描此二维码 <br />关注公众号，以接收任务推送</div>
      <div class="QR">
        <a-image :src="QR" :width="200"></a-image>
      </div>
      <div class="info">
        <span>{{ bandInfo.name }} {{ bandInfo.phone }}</span>
      </div>
      <div class="tips">
        <exclamation-circle-outlined />
        每个成员对应一个二维码，请勿泄露
      </div>
    </div>
  </a-modal>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" class="pagination" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />
  <!-- </div> -->
</template>

<script>
import { createVNode, nextTick, onMounted, reactive, toRefs, watch } from 'vue';
import { getHouseList, taskAddMember, taskDelMember, taskEditMember, taskEditStatus, taskGenerateMemberQr, taskMemberList } from '@/api/api';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import store from '@/store/pms/landlord/index'; //VUEX
import { message, Modal } from 'ant-design-vue';
import { verifyEmail, verifyPhone } from '@/common/validator';

export default {
  components: {
    ExclamationCircleOutlined,
  },
  setup() {
    let { countTable, imgCut } = useUtils();

    // 搜索
    const search = reactive({
      topDom: '',
      searchLoading: false,
      searchForm: {
        start: 0,
        limit: store.getters.getPageSize,
      },
    });

    // 表格
    const table = reactive({
      tableHeight: '',
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          key: 'id',
          align: 'center',
          width: 100,
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          key: 'email',
          customRender: ({ text }) => {
            if (!text) {
              return '-';
            }
          },
        },
        {
          title: '负责的房间',
          dataIndex: 'hname',
          key: 'hname',
          width: 200,
          customRender: ({ text }) => {
            if (!text) {
              return '-';
            }
          },
        },
        {
          title: '微信通知',
          dataIndex: 'weixin',
          key: 'weixin',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
        },
        {
          title: '停用',
          dataIndex: 'status',
          key: 'status',
          customRender: ({ text }) => {
            if (text == 1) {
              return '-';
            } else {
              return '已停用';
            }
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          align: 'center',
        },
      ],
      getTableData() {
        search.searchLoading = true;
        taskMemberList({
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      handleEditStatus(item, status) {
        let text = status == 2 ? '停用' : '启用';
        Modal.confirm({
          title: `确定${text}此成员？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            taskEditStatus({ mid: item.id, status: status }).then(res => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      handleDelNumber(item) {
        Modal.confirm({
          title: `确定删除此成员？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            taskDelMember({ mid: item.id }).then(res => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      handleEdit(item) {
        modal.modalTitle = '修改成员';
        modal.searchRoom();
        nextTick(() => {
          modal.addForm.name = item.name;
          modal.addForm.phone = item.phone;
          modal.addForm.auth = item.auth;
          modal.addForm.email = item.email;
          modal.addForm.remark = item.remark;
          modal.addForm.mid = item.id;
          modal.addForm.hids = item.hids ? item.hids.split(',').map(Number) : [];
        });
        modal.visibleAdd = true;
      },
    });

    // 弹窗
    const modal = reactive({
      visibleBand: false,
      QR: '',
      bandInfo: {},
      handleOpenBand(item) {
        modal.visibleBand = true;
        modal.bandInfo = item;
        taskGenerateMemberQr({
          mid: item.id,
        })
          .then(res => {
            modal.QR = res.data.url;
          })
          .catch(() => {
            modal.QR = '';
          });
      },
      customRow(record) {
        if (record.status == 2) {
          return {
            style: {
              color: '#999999',
            },
          };
        }
      },

      modalTitle: '',
      visibleAdd: false,
      handleOpenModal() {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.addForm.hids = [];
        modal.modalTitle = '添加成员';
        modal.visibleAdd = true;
      },
      formRef: '', //表单验证
      addForm: {
        name: '',
        phone: '',
        email: '',
        auth: 1,
        remark: '',
        hids: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            validator: verifyPhone,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: false,
            validator: verifyEmail,
            trigger: 'blur',
          },
        ],
        auth: [
          {
            required: false,
            message: '请选择权限',
            trigger: 'change',
            type: 'number',
          },
        ],
        remark: [
          {
            required: false,
            message: '请输入描述',
            trigger: 'blur',
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        if (modal.modalTitle == '添加成员') {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            let obj = JSON.parse(JSON.stringify(modal.addForm));
            obj.hids = obj.hids.toString();
            taskAddMember(obj)
              .then(res => {
                message.success(res.msg);
                nextTick(() => {
                  modal.isLoading = false;
                });
                modal.visibleAdd = false;
                table.getTableData();
              })
              .catch(() => {
                modal.isLoading = false;
              });
          });
        } else {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            let obj = JSON.parse(JSON.stringify(modal.addForm));
            obj.hids = obj.hids.toString();
            taskEditMember(obj)
              .then(res => {
                message.success(res.msg);
                nextTick(() => {
                  modal.isLoading = false;
                });
                modal.visibleAdd = false;
                table.getTableData();
              })
              .catch(() => {
                modal.isLoading = false;
              });
          });
        }
      },
      roomList: [],
      searchRoom() {
        getHouseList({
          start: 0,
          limit: 99,
        }).then(res => {
          modal.roomList = res.data.list;
        });
      },
      throttle: false,
      throttleInput: '',
      roomFilter(input) {
        modal.throttleInput = input;
        if (modal.throttle) {
          return;
        }
        modal.throttle = true;
        setTimeout(() => {
          getHouseList({
            start: 0,
            limit: 99,
            name: modal.throttleInput,
          }).then(res => {
            modal.roomList = res.data.list;
            modal.throttle = false;
          });
        }, 1000);
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 10;
      }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss">
.weixin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .QR {
  }
  .info {
    font-weight: bold;
  }
  .tips {
    color: #f5a623;
    margin-top: 20px;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>
